import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { electronicInvoicingApi } from "../../api/electronicInvoicingApi";

export default function InvoicesPage() {
  const { token } = useAuth() as any;
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState<string>("");
  const [notifications, setNotifications] = useState<any[]>([]);

  const load = useCallback(() => {
    setLoading(true);
    electronicInvoicingApi
      .listInvoices(token)
      .then(setItems)
      .finally(() => setLoading(false));
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const createInvoice = async () => {
    await electronicInvoicingApi.createInvoice(token, {
      customerName: "Cliente demo",
      total: 100,
    });
    load();
  };

  const genXml = async (id: string) => {
    await electronicInvoicingApi.generateXml(token, id);
    load();
  };

  const send = async (id: string) => {
    await electronicInvoicingApi.sendInvoice(token, id);
    load();
  };

  const loadNotifications = async (id: string) => {
    setSelected(id);
    const rows = await electronicInvoicingApi.listInvoiceNotifications(token, id);
    setNotifications(rows);
  };

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Fatture</h3>
        <button className="btn btn-primary" onClick={createInvoice}>Nuova fattura</button>
      </div>
      <div className="card shadow-sm">
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th>Numero</th>
                <th>Cliente</th>
                <th>Totale</th>
                <th>Stato</th>
                <th className="text-end">Azioni</th>
              </tr>
            </thead>
            <tbody>
              {items.map((x) => (
                <tr key={x.id}>
                  <td>{x.number}/{x.year}</td>
                  <td>{x.customerName}</td>
                  <td>{x.total}</td>
                  <td><span className="badge text-bg-secondary">{x.status}</span></td>
                  <td className="text-end">
                    <div className="d-flex gap-2 justify-content-end">
                      <button className="btn btn-sm btn-outline-secondary" onClick={() => genXml(x.id)}>Genera XML</button>
                      <button className="btn btn-sm btn-outline-primary" onClick={() => send(x.id)}>Invia ad Aruba</button>
                      <button className="btn btn-sm btn-outline-info" onClick={() => loadNotifications(x.id)}>Esiti</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!loading && items.length === 0 && (
                <tr><td colSpan={5} className="text-center text-muted py-4">Nessuna fattura</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {selected && (
        <div className="card shadow-sm mt-3">
          <div className="card-header fw-semibold">Esiti/Notifiche fattura</div>
          <div className="table-responsive">
            <table className="table mb-0">
              <thead className="table-light"><tr><th>Quando</th><th>Tipo</th><th>Stato</th><th>Messaggio</th></tr></thead>
              <tbody>
                {notifications.map((n) => (
                  <tr key={n.id}>
                    <td>{new Date(n.receivedAt).toLocaleString("it-IT")}</td>
                    <td>{n.notificationType}</td>
                    <td>{n.status}</td>
                    <td>{n.message ?? "-"}</td>
                  </tr>
                ))}
                {notifications.length === 0 && <tr><td colSpan={4} className="text-center text-muted">Nessuna notifica</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
